// providers/I18nProvider.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import { LoadingSpinner } from "../components/index.js";
import { Box } from "@mui/material";

//sonarqube
import PropTypes from "prop-types";


const I18nProvider = ({ children }) => {
  // react-i18next v17 + i18next v26: use the hook's own `ready` flag.
  // This is reliable regardless of how quickly the async backend loads.
  const { ready } = useTranslation(
    ["projectTranslation", "layoutTranslation", "authTranslation", "userTranslation", "errorTranslation"],
    { useSuspense: false }
  );

  if (!ready) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          width: "100%",
          p: 2,
        }}
      >
        <LoadingSpinner message="Loading translations..." />
      </Box>
    );
  }

  return children;
};

//sonarqube
I18nProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default I18nProvider;
